import { createSlice } from "@reduxjs/toolkit";
import {
  fetchCustomersBalance,
  fetchCustomersList,
  fetchCustomersCode,
  fetchEmployees,
  fetchLocations,
  fetchCustomersGroupList,
  fetchGroupCustomers,
} from "./customersThunks";

const customersSlice = createSlice({
  name: "customers",
  initialState: {
    customersList: null,
    customersGroupList: null,
    groupedSelectedCustomers: [],
    groupedPendingCustomers: [],
    selectedCustomer: null,
    isEditCustomer: false,
    customerCode: null,
    employees: null,
    locations: null,
    loading: false,
    error: null,
  },
  reducers: {
    // Add any synchronous reducers if needed
    setSelectedCustomer: (state, action) => {
      state.selectedCustomer = action.payload;
    },
    setIsEditCustomer: (state, action) => {
      state.isEditCustomer = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle fetch customer balance
      .addCase(fetchCustomersBalance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomersBalance.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCustomer = action.payload;
      })
      .addCase(fetchCustomersBalance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Handle fetchSalesList
      .addCase(fetchCustomersList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomersList.fulfilled, (state, action) => {
        state.loading = false;
        state.customersList = action.payload;
      })
      .addCase(fetchCustomersList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Handle fetchSalesList
      .addCase(fetchCustomersGroupList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomersGroupList.fulfilled, (state, action) => {
        state.loading = false;
        state.customersGroupList = action.payload;
      })
      .addCase(fetchCustomersGroupList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Handle fetchSalesList
      .addCase(fetchGroupCustomers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGroupCustomers.fulfilled, (state, action) => {
        state.loading = false;
        state.groupedSelectedCustomers = action.payload.grouped_customers || [];
        state.groupedPendingCustomers = action.payload.pending_customers || [];
      })
      .addCase(fetchGroupCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // fetch customer code here
      .addCase(fetchCustomersCode.fulfilled, (state, action) => {
        state.loading = false;
        state.customerCode = action.payload;
      })

      // fetch customer location here
      .addCase(fetchLocations.fulfilled, (state, action) => {
        state.loading = false;
        state.locations = action.payload;
      })

      // fetch employees here
      .addCase(fetchEmployees.fulfilled, (state, action) => {
        state.loading = false;
        state.employees = action.payload;
      });
  },
});
export const { setIsEditCustomer, setSelectedCustomer } =
  customersSlice.actions;

export default customersSlice.reducer;
